<template>
  <v-main>
    <TabbedInterface
      class="clean maxh-1bar"
      ref="interface"
      title="Veículo"
      :tabComponents="allTabComponents"
      :value="client"
      @reload="reload"
      orientation="vertical"
    >
      <template v-slot:topbar-title>
        <v-icon>mdi-developer-board</v-icon>
        <v-toolbar-title class="ml-4">{{ title }}</v-toolbar-title>
      </template>
      <template v-slot:sidebar-title>
        <SidebarHeaders :headers="headers" class="mt-1 pa-2" />

        <OperationsMenu :clientId="client.id" class="ma-4" @reload="reload" />
      </template>
    </TabbedInterface>
  </v-main>
</template>

<script>
import TabbedInterface from 'oderon-vue/cpts/tabbed-interface/TabbedInterface.vue'
import SidebarHeaders from 'oderon-vue/cpts/tabbed-interface/SidebarHeaders.vue'
import ClientOverviewTab from './ClientOverviewTab.vue'
import ClientHistoryTab from './history/ClientHistoryTab.vue'
import ClientFwUpdatesTab from './ClientFwUpdatesTab.vue'
import ClientUnpauser from './unpauser/ClientUnpauser'
import ClientVehicleTab from './ClientVehicleTab.vue'
import ClientWifiTab from './ClientWifiTab.vue'
import ClientTripsTab from './ClientTripsTab.vue'
import ClientEventsTab from './ClientEventsTab.vue'
import ClientOccursTab from './ClientOccursTab.vue'
import ClientHeatmapTab from './ClientHeatmapTab.vue'
import ClientMailboxTab from './mailbox/ClientMailboxTab.vue'
import ClientMailboxComparator from './mailbox-comparator/Main.vue'
import OperationsMenu from '../operations/OperationsMenu.vue'
import { Client } from '@/models'

export default {
  components: {
    TabbedInterface,
    OperationsMenu,
    SidebarHeaders
  },
  props: {
    cid: { required: true }
  },
  watch: {
    cid() {
      this.fetchData()
    }
  },
  data() {
    return {
      client: null
    }
  },
  computed: {
    allTabComponents() {
      return [
        ClientOverviewTab,
        ClientMailboxTab,
        ClientHistoryTab,
        ClientFwUpdatesTab,
        ClientUnpauser,
        ClientMailboxComparator,
        ClientVehicleTab,
        ClientWifiTab,
        ClientTripsTab,
        ClientEventsTab,
        ClientOccursTab,
        ClientHeatmapTab
      ]
    },

    title() {
      // let orgLabel = this.mainOrg && this.mainOrg.label
      let vcode = this.client.vehicle && this.client.vehicle.code
      // let vcode = this.client && this.client.vehicleCode
      let cid = this.client && this.client.id

      return `${cid} ─ ${vcode || '(s/placa)'}`
    },

    headers() {
      let { id, vehicleId } = this.client
      let { id: orgId, label: orgLabel } = this.client.organization

      let vcode = this.client.vehicle && this.client.vehicle.code

      let result = [
        { icon: 'mdi-developer-board', text: id, primary: true },
        {
          icon: 'mdi-car',
          text: vcode || '(sem placa)',
          action: vehicleId == null ? '' : '#' + vehicleId
        },
        {
          icon: 'mdi-domain',
          text: orgLabel,
          path: orgId == -1 ? null : '/orgs/' + orgId,
          action: orgId == -1 ? '' : '#' + orgId
        }
      ]

      return result
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    reload() {
      this.$refs.interface.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.client = await Client.findById(this.cid)
      let v = (this.client.vehicle && this.client.vehicle.code) || '(s/placa)'
      let o = this.client.org.label
      this.$setTitle(`${v} ─ ${this.client.id} ─ ${o}`)
    }
  }
}
</script>
